import React, { useContext } from 'react';
import { LocationContext } from '../contexts/LocationContext';
import { LoadingContext } from '../contexts/LoadingContext';
import { ContentContext } from '../contexts/ContentContext';
import { useLocation } from 'react-router-dom';

const useLocationContext = () => {
    return useContext(LocationContext);
};

const useLoading = () => {
    return useContext(LoadingContext);
};

const useContent = () => {
    return useContext(ContentContext);
};

const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
};

export { useLoading, useContent, useLocationContext, useQuery };
